import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import FacebookIcon from '@material-ui/icons/Facebook';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import PersonIcon from '@material-ui/icons/Person';
import PhoneIcon from '@material-ui/icons/Phone';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta';
import { AppConfig } from '../../../AppConfig';
import { AppHelper } from '../../../helpers/AppHelper';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';

const webFormIcon = require('../../../assets/images/web_form_submitted.svg');
const multiActionIcon = require('../../../assets/images/automation.svg');

function isRuleLive(state) {
  return String(state || '').toUpperCase() === 'LIVE'
}

function withRuleState(list, id, state) {
  return (list || []).map(item => (item && item.id === id ? { ...item, state } : item))
}

export class Automations extends BaseEntityPageSlixta {
  constructor(props) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageTitle = Helper.getString('automation-journeys')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('automations') },
    ]
    this.toFetch = [
      { key: 'rules', ms: this.ms, method: 'GET', paths: ['rules'], queryParams: { orgId: this.orgId, pb: 'fieldDef'} },
    ]
    this.apiData = {
      orgId: this.orgId
    }
    this.pageKey = Helper.getString('automations')
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Title: (current) => {
        return <div>
          <div className={css(Styles.titleContainer)}>
            <span className={css(Styles.line1)}>{current.title}</span>
            <span className={css(Styles.line3)}>Created: {Helper.formatTimestamp(current.createdTs)}</span>
          </div>
        </div>
      },
      Info: (current) => this.renderAutomationFlow(current),
      Status: (current) => {
        if (!current) return null
        const isLive = isRuleLive(current.state)
        const isToggling = Boolean(this.state.togglingIds && this.state.togglingIds[current.id])
        return (
          <div className={css(Styles.statusCell)} onClick={e => e.stopPropagation()}>
            {isToggling ? (
              <CircularProgress size={20} style={{ margin: '0 8px' }} />
            ) : (
              <Switch
                checked={isLive}
                onChange={e => this.onToggleRuleState(current, e.target.checked)}
                color='primary'
                size='small'
              />
            )}
          </div>
        )
      },
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.headerActions = [
      {
        label: 'Add new',
        onClick: () => this.openModalForAdd(),
      },
      {
        label: 'Refresh',
        tooltip: 'Refresh',
        icon: 'refresh',
        type: 'icon-label',
        onClick: () => this.fetchItems(),
      }
    ]
    this.state = {
      ...this.state,
      togglingIds: {},
    }
  }

  formatAutomationLabel(value) {
    if (!value || typeof value !== 'string') {
      return ''
    }
    return value.replace(/_/g, ' ').toLowerCase()
  }

  getEventTypeIcon(eventType) {
    if (!eventType) return null
    switch(eventType) {
    case 'LINKEDIN_FORM_SUBMITTED':
      return <LinkedInIcon style={{ fontSize: 21, color: '#bb76e6' }} />
    case 'META_FORM_SUBMITTED':
      return <FacebookIcon style={{ fontSize: 21, color: '#bb76e6' }} />
    case 'WHATSAPP_MESSAGE':
      return <WhatsAppIcon className={css(Styles.waicon)} />
    case 'CONTACT_CREATED':
      return <i className='material-icons-outlined' style={{ fontSize: 21, color: '#bb76e6' }}>person_add</i>
    case 'CONTACT_UPDATED':
      return <i className='material-icons-outlined' style={{ fontSize: 21, color: '#bb76e6' }}>person</i>
    case 'CONTACT_CREATED_OR_UPDATED':
      return <i className='material-icons-outlined' style={{ fontSize: 21, color: '#bb76e6' }}>person</i>
    case 'CALL_INCOMING':
      return <i className='material-icons-outlined' style={{ fontSize: 21, color: '#bb76e6' }}>phone_callback</i>
    case 'WEB_FORM_SUBMITTED':
      return <img src={webFormIcon} className={css(Styles.triggerIconImage)} />
    default:
      return null
    }
  }

  getAutomationType(actions) {
    if (!actions || typeof actions !== 'object') {
      return null
    }
    const actionList = Object.values(actions).filter(Boolean)
    if (!actionList.length) {
      return null
    }
    const leadRouting = actionList.some(action => action && (
      action.iType === 'ROUTE_LEAD' ||
      (action.iType === 'UPDATE_CONTACT' && action.attrName === 'subOrgId')
    ))
    const sendWhatsappCount = actionList.filter(action => action && action.iType === 'SEND_WHATSAPP').length
    const enrollSequence = actionList.some(action => action && action.iType === 'ENROL_IN_SEQUENCE')
    if (leadRouting) {
      return 'Routing'
    } else if (sendWhatsappCount === 1) {
      return 'Auto Response'
    } else if (sendWhatsappCount > 1) {
      return 'Nurture'
    } else if(enrollSequence) {
      return 'Enroll in Sequence'
    } else if (actionList.length >= 1) {
      return 'Automation'
    }
    return null
  }

  getTriggerLabel(current) {
    if (!current || !current.eventType) {
      return 'Trigger: None'
    }
    return `Trigger: ${this.formatAutomationLabel(current.eventType)}`
  }

  getActionTypeIcon(iType,actionData = null) {
    if (!iType) return null
    const iconStyle = { fontSize: 21, color: '#bb76e6', textAlign: 'center' }
    switch(iType) {
    case 'SEND_WHATSAPP':
      return <WhatsAppIcon style={iconStyle} />
    case 'SEND_EMAIL':
      return <i className='material-icons-outlined' style={iconStyle}>email</i>
    case 'ROUTE_LEAD':
      return <i className='material-icons-outlined' style={iconStyle}>fork_right</i>
    case 'UPDATE_CONTACT':
      if (actionData && actionData.attrName) {
        if (actionData.attrName === 'assignee' || actionData.attrName === 'subOrgId') {
          return <i className='material-icons-outlined' style={iconStyle}>fork_right</i>
        }
      }
      return <i className='material-icons-outlined' style={iconStyle}>person</i>
    case 'ENROL_IN_SEQUENCE':
      return <i className='material-icons-outlined' style={iconStyle}>dynamic_feed</i>
    case 'SEND_META_CAPI':
      return <FacebookIcon style={iconStyle} />
    case 'REGISTER_ZOOM':
      return <i className='material-icons-outlined' style={iconStyle}>videocam</i>
    case 'ADD_NOTE':
      return <i className='material-icons-outlined' style={iconStyle}>note_add</i>
    case 'WEBHOOK_PUSH':
      return <i className='material-icons-outlined' style={iconStyle}>webhook</i>
    default:
      return <i className='material-icons-outlined' style={iconStyle}>bolt</i>
    }
  }

  getActionLabel(actionType) {
    if (!actionType) {
      return 'Action: None'
    }
    return `Action: ${actionType}`
  }
  renderActionIcons(actions) {
    if (!actions || typeof actions !== 'object') {
      return <i className='material-icons-outlined' style={{ fontSize: 21, color: '#bb76e6' }}>block</i>
    }

    const actionArray = Object.values(actions)
      .filter(Boolean)
      .sort((a, b) => {
        const orderA = a && a.order ? parseInt(a.order, 10) : Number.MAX_SAFE_INTEGER
        const orderB = b && b.order ? parseInt(b.order, 10) : Number.MAX_SAFE_INTEGER
        return orderA - orderB
      })

    if (actionArray.length === 0) {
      return <i className='material-icons-outlined' style={{ fontSize: 21, color: '#bb76e6' }}>block</i>
    }
    if (actionArray.length > 1) {
      return (
        <Tooltip title='Multiple actions' placement='bottom'>
          <div>
            <img src={multiActionIcon} className={css(Styles.multiActionIconImage)} />
          </div>
        </Tooltip>
      )
    }

    const action = actionArray[0]
    return (
      <div className={css(Styles.actionIconsContainer)}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <Tooltip title={this.formatAutomationLabel(action.iType)} placement='bottom'>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {this.getActionTypeIcon(action.iType, action)}
            </div>
          </Tooltip>
        </div>
      </div>
    )
  }

  renderAutomationFlow(current) {
    const triggerIcon = this.getEventTypeIcon(current.eventType)
    const triggerLabel = this.getTriggerLabel(current)

    return (
      <div className={css(Styles.automationFlowContainer)}>
        {/* Trigger box */}
        <Tooltip title={triggerLabel} placement='bottom'>
          <div className={css(Styles.flowBox)}>
            {triggerIcon || <i className='material-icons-outlined' style={{ fontSize: 21, color: '#bb76e6', textAlign: 'center' }}>help_outline</i>}
          </div>
        </Tooltip>
        {/* Arrow */}
        <div className={css(Styles.flowArrow)}>→</div>
        {/* Action box with all action icons */}
        <div className={css(Styles.flowBox)}>
          {this.renderActionIcons(current && current.actions)}
        </div>
      </div>
    )
  }

  getFirstAction(actions) {
    if (!actions || typeof actions !== 'object') {
      return null
    }
    const actionList = Object.values(actions).filter(Boolean)
    if (!actionList.length) {
      return null
    }
    const sortedActions = actionList.sort((a, b) => {
      const orderA = a && a.order ? parseInt(a.order, 10) : Number.MAX_SAFE_INTEGER
      const orderB = b && b.order ? parseInt(b.order, 10) : Number.MAX_SAFE_INTEGER
      return orderA - orderB
    })
    return sortedActions[0] || null
  }

  getAutomationTriggerSummary(current) {
    if (!current || !current.eventType) {
      return 'Trigger: None'
    }
    return `Trigger: when ${this.formatAutomationLabel(current.eventType)}`
  }

  getAutomationActionSummary(current) {
    const firstAction = this.getFirstAction(current && current.actions)
    if (!firstAction || !firstAction.iType) {
      return 'Action: None'
    }
    const totalActions = current && current.actions ? Object.keys(current.actions).length : 0
    const actionLabel = this.formatAutomationLabel(firstAction.iType)
    if (totalActions > 1) {
      return `Action: ${actionLabel} (+${totalActions - 1} more)`
    }
    return `Action: ${actionLabel}`
  }

  putRule(id, { title, state }) {
    return ApiHelper.callAwait({
      ms: this.ms,
      method: 'PUT',
      paths: ['rules', id],
      queryParams: { orgId: this.orgId },
      jsonBody: {
        orgId: this.orgId,
        title,
        state,
      },
    })
  }

  onToggleRuleState = async (current, enabled) => {
    const id = current && current.id
    if (!id) return
    if (enabled === isRuleLive(current.state)) return
    const state = enabled ? 'LIVE' : 'DISABLED'
    this.setState(prev => ({
      togglingIds: { ...(prev.togglingIds || {}), [id]: true },
    }))
    try {
      await this.putRule(id, {
        title: current.title || '',
        state,
      })
      this.setState(prev => ({
        items: withRuleState(prev.items, id, state),
        togglingIds: { ...(prev.togglingIds || {}), [id]: false },
      }))
      this.rules = withRuleState(this.rules, id, state)
      const name = String(current.title || '').trim() || 'Automation'
      this.showToast(`Automation "${name}" is now ${state}`, 'success')
    } catch (err) {
      this.setState(prev => ({
        togglingIds: { ...(prev.togglingIds || {}), [id]: false },
      }))
      this.showToast(Helper.getErrorMsg(err), 'error')
    }
  }

  showToast = (message, severity = 'success') => {
    this.setState({
      showToast: true,
      toastMsg: message,
      isErrorToast: severity === 'error',
    })
  }

  onFetchSuccess(results) {
    this.rulesResult = this.getResult(results, 'rules')
    this.rules = (this.rulesResult && Array.isArray(this.rulesResult.items)) ?  this.rulesResult.items : []
    this.fieldDef = this.rulesResult && this.rulesResult.fieldDef
    if(this.fieldDef) {
      this.fieldDef = Helper.removeAdvancedFields(this.fieldDef)
      const iTypeField = Helper.getField(this.fieldDef, 'iType')
      if(iTypeField) {
        iTypeField.hidden = true
      }
      const eventTypeField = Helper.getField(this.fieldDef, 'eventType')
      if(eventTypeField) {
        eventTypeField.label = 'Trigger Event'
        eventTypeField.placement = 'right'
      }
    }

    this.setState({
      items: this.rules
    })
  }

  openModalForAdd() {
    const fieldDef = JSON.parse(JSON.stringify(this.fieldDef))
    if(fieldDef) {
      const stateField = Helper.getField(fieldDef, 'state')
      if(stateField) {
        stateField.defaultValue = 'DISABLED'
        stateField.hidden = true
      }
      const titleField = Helper.getField(fieldDef, 'title')
      if (titleField) {
        titleField.defaultValue = Helper.nextNonClashingIndexedName(
          'new_automation_',
          (this.state.items || []).map(r => r && r.title)
        )
      }
    }
    super.openModalForAdd(fieldDef)
  }

  onAdd() {
    this.apiData = {
      orgId: this.orgId,
    }
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['rules'], queryParams: {orgId: this.orgId} }),
    });
  }

  async customSubmit(options) {
    const { formType, formData, caller } = options
    if (formType === 'add' && this.formDefinition && this.formDefinition._subType === 'create-copy') {
      ApiHelper.callAwait({
        ms: AppConfig.CDP_MS.ENDPOINT,
        method: 'POST',
        paths: ['miscs', 'create-copy'],
        queryParams: { orgId: this.orgId},
        jsonBody: formData,
      }).then((response) => {
        window.open(this.automationDetailPath(response.id), '_self')
      }).catch((err) => {
        const errorMessage = Helper.getErrorMsg(err)
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false,
        })
      })
      return
    }
    return caller.submit.call(caller, formData, true)
  }

  automationDetailPath(id) {
    const path = this.baseRoute() + '/automations/' + id
    if (AppHelper.isSettingEnabled(this.orgId, 'AUTOMATION_VISUAL_BUILDER')) {
      return path + '?visual'
    }
    return path
  }

  onCompleteAction(options) {
    const apiInvokeData = options && options.apiInvokeData
    const resp = apiInvokeData && apiInvokeData.responseBody
    if (apiInvokeData && apiInvokeData.method === 'POST' && resp && resp.id && this.props.history && this.props.history.push) {
      this.setState({ modalOpen: false, dialogApiData: apiInvokeData })
      this.props.history.push(this.automationDetailPath(resp.id))
      return
    }
    this.setState({ modalOpen: false, items: [], dialogApiData: apiInvokeData })
    this.fetchItems()
  }

  onActions = (current) => {
    const actions = []
    if (AppHelper.isSettingEnabled(this.orgId, 'AUTOMATION_VISUAL_BUILDER')) {
      actions.push(
        <Link to={this.baseRoute() + '/automations/' + current.id + '?visual'} key={current.id + '-visual'}>
          <Tooltip title='View Visual Builder' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>account_tree</i>
            </span>
          </Tooltip>
        </Link>
      )
    }
    actions.push(
      <Link to={this.baseRoute() + '/automations/' + current.id} key={current.id}>
        <Tooltip title='View Rule' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>arrow_forward_ios</i>
          </span>
        </Tooltip>
      </Link>
    )
    return actions
  }

  onMenuItems = (current) => {
    const actions = []
    const menuItems = [
      {
        current: current,
        key: current.id + 'create-copy',
        action: () => {
          UiHelper.openModalForCreateCopy.call(this, current, 'RULE')
        },
        title: Helper.getString('createcopy'),
        icon: 'copy',
      },
    ]
    menuItems.map(item => {
      actions.push(UiHelper.actionButton(item))
    })
    return actions
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) { return '' }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }
}

const Styles = StyleSheet.create({
  line1: {
    fontSize: 16
  },
  line2: {
    fontSize: 12,
    color: 'gray',
    display: 'block'
  },
  line3: {
    fontSize: 12,
    color: 'gray',
    display: 'block',
    textAlign:'left'
  },
  statusCell: {
    display: 'flex',
    alignItems: 'center',
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 5
  },
  statusBadge: {
    backgroundColor: AppTheme.primaryBg,
    padding: 5,
    borderRadius: 10,
    wordBreak: 'keep-all',
    display: 'block',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
  },
  statusBadgeLive: {
    backgroundColor: '#3BDE86',
    color: '#222222',
    fontSize:15,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    marginBottom: 4,
    gap: 6
  },
  automationFlowContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  flowBox: {
    width: 60,
    height: 45,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #F5F5F5',
    transition: 'all 0.2s ease',
    flexShrink: 0,
    textAlign: 'center',
  },
  flowArrow: {
    fontSize: 16,
    fontWeight: 500,
    color: '#666666',
    flexShrink: 0,
    marginRight: 2,
    marginLeft: 2,
  },
  notConfigured: {
    opacity: 0.7,
    fontSize: 11,
    color: '#777777',
    fontWeight: 500,
    textAlign: 'center',
    padding: '2px 4px',
    whiteSpace: 'nowrap',
  },
  waicon: {
    color: '#bb76e6',
    padding: 0,
    fontSize: 21,
  },
  actionIconsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    gap: 3,
  },
  triggerIconImage: {
    height: 25,
    width: 25,
    objectFit: 'contain',
    display:'flex',
    alignItems: 'center',
    justifyContent: 'center',
    filter: 'drop-shadow(0.25px 0 0 #bb76e6) drop-shadow(-0.25px 0 0 #bb76e6) drop-shadow(0 0.25px 0 #bb76e6) drop-shadow(0 -0.25px 0 #bb76e6)',
  },
  multiActionIconImage: {
    height: 29,
    width: 29,
    objectFit: 'contain',
    display:'flex',
    alignItems: 'center',
    justifyContent: 'center',
    filter: 'drop-shadow(0.25px 0 0 #bb76e6) drop-shadow(-0.25px 0 0 #bb76e6) drop-shadow(0 0.25px 0 #bb76e6) drop-shadow(0 -0.25px 0 #bb76e6)',
  },
})